import React, { useEffect, useState, useRef } from "react";
import {Dimensions,Image,TouchableOpacity,View}from"react-native";
import Header from "../../common/Header";
import * as RootNavigation from "../../utilities/RootNavigation";
import CImage from "../../common/CImage";
import CustomButton from "../../common/CustomButton";
import CustomTextInput from "../../common/CustomTextInput";
import { useLocation } from "react-router-dom";
import CustomInput from "../../common/CustomInput";
import { sendOtp,validateOtp,getEncKey, resetPassword,getCpatcha} from "../../api/apiManager";
import { Encryption as encrypt,decryptCaptcha } from "../../utilities/Encryption";
import ModalAlert from "../../common/ModalAlert";
import LoginByVrn from "../../screens/login/LoginByVrnScreen";
import LoginTabIcons from "./LoginTabIcons";
import LoginRightWidget from "./LoginRightWidget";
import LoginFooter from "./LoginFooter";
import LoginMoibleContent from "./LoginMobileContent";
import CountdownTimer from "../../common/CTimer.web";
import CText from "../../common/CText";
import useStyles from "./ForgotPasswordScreen_Styles";
import CCaptcha from "../../common/CCaptcha";
import CView from '../../styles/CommonStyle';

export default function ForgotPasswordScreen(props) {
  const { state } = useLocation();
  const passwordPattern = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*&^()])[A-Za-z\d@#$!%*&^()]{8,15}/;
  const otpPattern = /^\d{6}$/;
  const styles = useStyles();
  const [otp, setOtp] = useState("");
  const [screenName, setScreenName] = useState("1");
  const [passwordString, setPasswordString] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPasword, setShowPasword] = useState(false);
  const [showConfirmPasword, setShowConfirmPasword] = useState(false);
  const [mobile, setMobile] = useState("");
  const [isPasswordMatch, setIsPasswordMatch] = useState(true);
  const [reqId, setReqId] = useState("");
  const [otpMsg, setOtpMsg] = useState("");
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [showLoginByVrn, setShowLoginByVrn] = useState(false);
  const [captcha, setCaptcha] = useState('');
  const [captchaId, setCaptchaId] = useState("");
  const [captchaText, setCaptchaText] = useState("");
 
  const counterRef = useRef(null);
const [alertModal, setAlertModal] = useState({title: "",status: "",message: "",navigateScreen: "",actionButton: "",});
 useEffect(() => {
    if ( state &&
      (state?.resError != "" ||
        state?.resError != undefined ||
        state?.resError != null)
    ) {
      setScreenName("3");
      setReqId(state?.reqId);
      setMobile(state?.mobile);
    } else {
      setScreenName("1");
    }
  }, [state?.resError]);
useEffect(() => {
    if (state?.screenName === 3) {
      setScreenName("3");
      setReqId(parseInt(state?.reqId));
      setMobile(state?.mobileNo);
    }
  }, [state?.screenName]);

  const onCloseModal = () => {
    setAlertModalVisible(false);
  };
  useEffect(()=>{
    generateCaptcha();
  },[])

  const generateCaptcha = () => {
    setCaptcha("")
     getCpatcha()
       .then((res) => {
         decryptCaptcha(res?.data).then((res) => {
           setCaptchaText(res?.captchaCode)
           setCaptchaId(res?.captchaId)
         });
       }).catch((err) => {
         const routeObj = { title: "Captcha", type: "Error", msg: err?.response?.data?.message, btnText: "Ok", navigation: "Login", }
         RootNavigation.navigate("ResponseScreen", { data: routeObj })
       });
   };
const onSubmit = () => {
    if (passwordString.length >= 8) {
      if (passwordString === confirmPassword) {
        setIsPasswordMatch(true);
        getEncKey()
          .then(async (res) => {
            if (res.statusCode == 200) {
              const encKey = res?.data || "";
              const encryptedId = await encrypt(mobile, encKey);
              const encryptedPassword = await encrypt(passwordString, encKey);
              var reqObj = {
                userCd: encryptedId,
                password: encryptedPassword,
                requestId: reqId + "",
                type: "frgtPassCaptcha",
              };
              await resetPassword(reqObj)
                .then((res) => {
                  if (res.data.statusCode == 1010) {
                    const routeObj = {
                      title: "Forgot Password",
                      type: "success",
                      msg: res?.data?.message,
                      btnText: "Ok",
                      navigation: "Login",
                      reqId: reqId,
                      mobile: mobile,
                    };
                    RootNavigation.navigate("ResponseScreen", {
                      data: routeObj,
                    });
                  } else if (res.data.statusCode == -1036 || 500) {
                    const routeObj = {
                      title: "Forgot Password",
                      type: "Error",
                      msg: res?.data?.message,
                      btnText: "Ok",
                      navigation: "ForgotPasswordScreen",
                      reqId: reqId,
                      mobile: mobile,
                    };
                    RootNavigation.navigate("ResponseScreen", {
                      data: routeObj,
                    });
                  }
                })
                .catch((err) => {})
                .catch((err) => {});
            }
          })
          .catch((err) => {});
      } else {
        setIsPasswordMatch(false);
      }
    }
  };
  const onClickGetOtp = () => {  
    getEncKey()
      .then(async (res) => {
        if (res.statusCode == 200) {
          const encKey = res?.data || '';
          const encryptedCaptcha = await encrypt(`${captchaId}:${captcha}`, encKey);
          let reqObj = {
            type: "frgtPassCaptcha",
            flag: "1",
            id: mobile,
            captcha: encryptedCaptcha,
          };
          onSendOtp(reqObj);
        }
      })
      .catch((err) => {
        const routeObj = { title: 'Login ', type: 'Error', msg: err?.response?.data?.message, btnText: 'Ok', navigation: 'Login' };
        RootNavigation.navigate('ResponseScreen', { data: routeObj });
      });
  };
  const onSendOtp = (reqObj) => {
    sendOtp(reqObj)
      .then((res) => {
        if (res?.data?.statusCode == 200 || res?.data?.statusCode == 1003) {
          setScreenName("2");
          setReqId(res?.data?.response?.otp);
          setOtpMsg(res?.data?.message);
        } else if (
          res?.data?.message ==
          "Multiple accounts are linked to this number. Please try using user id and password for login as login through mobile number is not allowed in this case"
        ) {
          RootNavigation.navigate("LoginByVrnScreen", {
            type: "forgotPassword",
            mobile: mobile,
          });
          setOtpMsg(res?.data?.message);
        } else if (
          res?.data?.statusCode == -1001 ||
          res?.data?.statusCode == -1007 ||
          res?.data?.statusCode == -1003 ||
          res?.data?.statusCode == -1004 ||
          res?.data?.statusCode == 500
        ) {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res?.data?.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        } else if (res?.data?.statusCode == -1032) {
          setOtpMsg(res?.data?.message);
          RootNavigation.navigate("LoginByVrnScreen");
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        if (err == "Error: Request failed with status code 401") {
        } else {
          console.log(err);
        }
      });
  };
  const resendOTP = () => {
    setOtp('');
    let reqObj = {
      type: 'frgtPassCaptcha',
      requestId: reqId,
      id: mobile,
    };
    onSendOtp(reqObj);
  };

 const onValidateOtp = () => {
    let reqObj = {
      type: "frgtPassCaptcha",
      otp: otp,
      requestId: reqId,
    };
    validateOtp(reqObj)
      .then((res) => {
        if ([-1008].includes(res?.data?.statusCode)) {
          const routeObj = {
            title: "Forgot Password",
            type: "Error",
            msg: res?.data?.message,
            btnText: "Ok",
            navigation: "SelectForgotScreen",
          };
          RootNavigation.navigate("ResponseScreen", { data: routeObj });
        } else if ([1008].includes(res?.data.statusCode)) {
          setScreenName("3");
        }
      })
      .catch((err) => {});
  };
 useEffect(() => {
    if (confirmPassword) {
      if (passwordString === confirmPassword) setIsPasswordMatch(true);
      else setIsPasswordMatch(false);
    }
  }, [confirmPassword]);
const renderForgotPasswordScreen = () => {
    return (
      <View style={styles.containerBox}>
        <View style={styles.rectangle41}>
          <TouchableOpacity onPress={() => RootNavigation.navigate("SelectForgotScreen")}>
            <CImage.BackIconWhite></CImage.BackIconWhite>
          </TouchableOpacity>
          <CText.loginText style={{ justifyContent: "center", paddingLeft: 10 }} >
            {"Forgot Password"}
          </CText.loginText>
        </View>
        {screenName == "1" ? (
          <View style={{ alignItems: "center", width: "80%", alignSelf: "center" }} >
            <CText.forgetPwHeader style={{ marginVertical: "10%", paddingBottom: 5 }} >
              {"User ID / Mobile Number"}
            </CText.forgetPwHeader>
            <View style={{ marginTop: 20, width: "100%" }}>
              <CustomTextInput
                value={mobile}
                onChangeText={setMobile}
                placeholder={"Enter User ID / Mobile Number"}
              />
              <Image
                source={require("../../assets/images/UID.png")}
                style={styles.iconUID}
              />
            </View>
            <CView W100>
                <CCaptcha  captcha={captcha} setCaptcha={setCaptcha} setCaptchaText={setCaptchaText} setCaptchaId={setCaptchaId} captchaText= {captchaText}/>
              </CView>
            <View style={{ marginTop: 30, width: 108, height: 37 }}>
              <CustomButton
                onPress={!mobile  || captcha!==captchaText? ()=>{} : onClickGetOtp}
                text={"Get OTP"}
                disable={!mobile || captcha!==captchaText}
              />
            </View>
          </View>
        ) : screenName == "2" ? (
          <View style={{ width: "80%", alignSelf: "center" }}>
            <CText.enterOtpDescStyle
              style={{
                lineHeight: 16,
                marginHorizontal: "5%",
                paddingTop: 20,
                opacity: 0.5,
              }}>
              {otpMsg}
            </CText.enterOtpDescStyle>
            <CText.enterOtpTxtStyle
              style={{
                marginHorizontal: "10%",
                marginTop: 30,
                marginBottom: 5,
                alignSelf: "center",
                paddingBottom: 5,
              }} >
              {"Enter OTP"}
            </CText.enterOtpTxtStyle>
              <CustomInput
              value={otp}
              onValueChanged={(e) => setOtp(e)}
              style={[styles.textInputStyle, { width: 280 }]}
              maxLength={6}
              pattern={/^\d{6}$/}
              errorMessage={"Enter Valid OTP"}
              type="number"
              keyboardType="numeric"
            />
            <View style={styles.resendViewStyle}>
              <CountdownTimer
                requestOtp={screenName == "2"}
                onClickGetOtp={resendOTP}
                counterRef={counterRef}
              />
            </View>
            <View
              style={{marginTop: 25,width: 108,height: 37,alignSelf: "center",}}>
              <CustomButton
                onPress={!otpPattern.test(otp) ? ()=>{} : onValidateOtp}
                text={"Next"}
                disable={!otpPattern.test(otp) ? true : false}
              />
            </View>
          </View>
        ) : (
          <View style={{ alignSelf: "center", width: "80%" }}>
            <CText.forgetNewPw style={{ paddingTop: 20 }}>
              {"Enter New Password"}
            </CText.forgetNewPw>
            <CText.forgetPw
              style={{ paddingTop: 20, paddingLeft: "0%", paddingBottom: 5 }}
            >
              {"Password"}
            </CText.forgetPw>
            <View style={{ width: "100%" }}>
              <CustomInput
                value={passwordString}
                onValueChanged={setPasswordString}
                maxLength={15}
                hidePassword={!showPasword}
                pattern={/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*&^()])[A-Za-z\d@#$!%*&^()]{8,15}/
                }
                style={{ width: 300, height: 40, fontFamily: "Inter", fontSize: 13, fontWeight: "bold", fontStyle: "normal",lineHeight: 15,letterSpacing: -0.26,textAlign: "left",color: "#6e6e6e",paddingLeft: 10,borderRadius: 5,}}
              />
              <TouchableOpacity onPress={() => setShowPasword(!showPasword)}  style={{ position: "absolute", right: 10, top: 10 }} >
                <Image
                  source={require("../../assets/images/Password.png")}
                  style={{ width: 20, height: 20, resizeMode: "center" }}
                />
              </TouchableOpacity>
              {!passwordPattern.test(passwordString) ? (
                <CText.helperTxtErrorStyle style={{ paddingTop: 3, opacity: 0.7 }}>
                  { "Password must contain one digit, one lowercase character, one uppercase character, one special symbol in the list !@#$%^&*() and length at least 8 characters and maximum of 15" }
                </CText.helperTxtErrorStyle>
              ) : null}
            </View>

            <CText.forgetPw style={{ paddingTop: "5%", paddingLeft: "0%", paddingBottom: 5 }}>{"Confirm Password"}</CText.forgetPw>
            <View>
              <CustomTextInput
                secureTextEntry={!showConfirmPasword}
                value={confirmPassword}
                onChangeText={setConfirmPassword}
                maxLength={15}
              />
              <TouchableOpacity onPress={() => setShowConfirmPasword(!showConfirmPasword)} style={{ position: "absolute", right: 10, top: 10 }} >
                <CImage.PasswordIcon></CImage.PasswordIcon>
              </TouchableOpacity>
              <CText.helperTxtStyle
                style={{
                  opacity: isPasswordMatch ? 0.4 : 0.7,
                  color: isPasswordMatch ? "#02122c" : "red",
                }}  >
                {"Both passwords must be matched"}
              </CText.helperTxtStyle>
            </View>
            <View style={styles.submiBtn}  >
              <CustomButton
                onPress={ !passwordString || !confirmPassword || !passwordPattern.test(passwordString) || !isPasswordMatch ? ()=>{} : onSubmit }
                text={"Submit"}
                disable={ !passwordString || !confirmPassword ||  !passwordPattern.test(passwordString) || !isPasswordMatch }
              />
            </View>
          </View>
        )}
      </View>
    );
  };
 return (
    <View style={styles.mainContainerStyle}>
      <View style={{ flex: 1 }}>
        <Header text={"Login"} />
         <View style={styles.bodyContainerStyle}>
          <View style={styles.bodyLeftViewStyle}>
            <View>
              {showLoginByVrn ? (
                <LoginByVrn
                  type={"forgotPassword"}
                  goNext={() => {
                    setShowLoginByVrn(false);
                    setScreenName("3");
                  }}
                  showLoginByVrn={(screen) => setShowLoginByVrn(screen)}
                  otpMsg={
                    "Multiple accounts are linked to this number. Please enter your vehicle registration number"
                  }
                />
              ) : (
                renderForgotPasswordScreen()
              )}
            </View>
        <LoginTabIcons />
          </View>
        <LoginRightWidget />
        </View>
        <View style={styles.mobileComponentStyle}>
          <View style={styles.logoWidget} >
              <CImage.IDFCLogo></CImage.IDFCLogo>
              <CImage.FFLogoSmall></CImage.FFLogoSmall>
          </View>
          <View style={styles.renderWidget}  >
             {showLoginByVrn ? (
                <LoginByVrn type={"forgotPassword"}
                  goNext={() => {
                    setShowLoginByVrn(false);
                    setScreenName("3");
                  }}
                  showLoginByVrn={(screen) => setShowLoginByVrn(screen)}
                  otpMsg={"Multiple accounts are linked to this number. Please enter your vehicle registration number"}
                /> 
                ) : ( renderForgotPasswordScreen())}
            
          </View>
          <LoginMoibleContent />
        </View>
        <LoginFooter />
      </View>
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
    </View>
  );
}
